<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Report-Export-Download",
  path: "download",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
